import React from "react";

import { ContentPreviewElementPopupProps, ContentPreviewElementPopupState } from "./models";

import { Box, Stack, Typography } from "@mui/material";

import { Trans } from "@lingui/macro";

import { Link } from "react-router-dom";

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

import "./style.scss";
import { PlayCircle } from "@mui/icons-material";
import { selectDescriptionByLanguage } from "utils";
import { ContentType, SegregationType } from "commons/form-constants";

export class ContentPreviewElementPopup extends React.Component<ContentPreviewElementPopupProps, ContentPreviewElementPopupState> {

    private player: any;
    private videoNode: any;
    private popupElementRef: any;

    componentDidMount() {

        let videoUrl: string = "";
        let contentType: string = "video/mp4"


        if (this.props.content.type === ContentType.VOD && this.props.content.vodAdditionalInfos) {
            videoUrl = !this.props.content.vodAdditionalInfos.needsEncoding ? (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content.vodAdditionalInfos.vodS3Key!) : (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content.vodAdditionalInfos.encodedContentS3Key!);
            if (!this.props.content.vodAdditionalInfos.needsEncoding)
                contentType = "video/" + this.props.content.vodAdditionalInfos.format;
            else
                contentType = "application/x-mpegURL"
        }


        if (this.props.content.type === ContentType.LIVE && this.props.content.liveAdditionalInfos) {
            videoUrl = this.props.content.liveAdditionalInfos.contentOutputUrl || "";
            contentType = "application/x-mpegURL"
        }


        let videoProps = {
            autoplay: true,
            controls: false,
            poster: (process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL) + this.props.content.thumbnailData.thumbnailS3Key!,
            controlBar: {
                'pictureInPictureToggle': true
            },
            sources: [{
                src: videoUrl,
                type: contentType
            }]
        }

        this.player = videojs(this.videoNode, videoProps, () => { });

    }

    componentWillUnmount(): void {
        if (this.player) {
            this.player.dispose();
        }
    }

    render(): React.ReactNode {

        return (<Box
            ref={(el) => this.popupElementRef = el}
            onMouseLeave={() => this.props.hideOverlay()}
            style={{
                zIndex: 999,
                width: "360px",
                height: "400px",
                marginRight: "-44px",
                backgroundColor: process.env.REACT_APP_THIRD_COLOR,
                border: "2px solid " + process.env.REACT_APP_SECONDARY_COLOR,
                borderRadius: "3%",
            }}
            className="cpep-main">
            {this.props.content.segregationType === SegregationType.PAY_PER_VIEW && <Box sx={{
                zIndex: 99999,
                position: "absolute",
                top: "0",
                left: "0",
                backgroundColor: process.env.REACT_APP_SECONDARY_COLOR,
                fontWeight: "bold",
                paddingLeft: "5px",
                paddingBottom: "5px",
                paddingRight: "15px",
                borderBottomRightRadius: "100%",
                color: process.env.REACT_APP_PRIMARY_COLOR
            }}>
                €
            </Box>}
            {this.props.content.segregationType === SegregationType.SUBSCRIPTION && <Box sx={{
                zIndex: 99999,
                position: "absolute",
                top: "0",
                left: "0",
                backgroundColor: process.env.REACT_APP_SECONDARY_COLOR,
                fontWeight: "bold",
                paddingLeft: "5px",
                paddingBottom: "5px",
                paddingRight: "20px",
                borderBottomRightRadius: "100%",
                color: process.env.REACT_APP_PRIMARY_COLOR
            }}>
                <Trans id="cpe-subscription-shorthand"> ABB </Trans>
            </Box>}

            <Box component="div" data-vjs-player style={{ width: "100%" }}>
                <video ref={node => this.videoNode = node} className="video-js vjs-16-9"></video>
            </Box>
            <Box sx={{ p: 2 }}>
                <Link to={{ pathname: `/player/${this.props.content.id}`, state: { comingFromDomain: true } }} style={{ textDecoration: "none" }}>
                    <Stack direction={"row"}
                        alignItems={"center"}
                        flex={1}
                        className="cpep-play-text"
                        sx={{ mb: 1 }}>
                        <PlayCircle style={{
                            fontSize: "32px",
                            marginRight: "5px"
                        }} />
                        <Typography
                            style={{
                                fontSize: "18px",
                                marginBottom: "5px",
                                fontWeight: "bold"
                            }}>
                            <Trans id="cpep-play-button">
                                Riproduci
                            </Trans>
                        </Typography>
                    </Stack>
                </Link>
                <Typography variant={"body1"}
                    sx={{
                        fontWeight: "bold",
                        color: "white"
                    }}>
                    {selectDescriptionByLanguage(this.props.content.title, this.props.content.language)}
                </Typography>
                <Typography variant={"body2"}
                    sx={{
                        fontStyle: "italic",
                        color: "white",
                        overflow: "hidden",
                        whiteSpace: "initial"
                    }}>
                    {selectDescriptionByLanguage(this.props.content.synopsis, this.props.content.language)}
                </Typography>
                {this.props.content.segregationType === SegregationType.PAY_PER_VIEW && <Typography variant={"body2"}
                    sx={{
                        color: process.env.REACT_APP_SECONDARY_COLOR,
                        fontWeight: "bold",
                        overflow: "hidden",
                        whiteSpace: "initial"
                    }}>
                    <Trans id="cpep-price-ppv">Tuo a soli</Trans> {this.props.content.payPerViewSegregationAdditionalInfos?.price} {this.props.content.payPerViewSegregationAdditionalInfos?.currency}
                </Typography>}
            </Box>
        </Box >)
    }

}